import http from "@/common/http.service";

const FORM_URL = "form";
const TEMPLATE_URL = "form/template";
const FREQUENT_URL = "frequent-fields";
const CUSTOM_FIELD_URL = "contact-fields/list";
const SAVE_CUSTOM_FIELD = "fields/save";
const SAVE_FORM_FIELD = "form-property/add-contact-field/";
const PUBLISH_FORM = "form/publish/";
const SAVE_FORM_ONLY_PROP = "form-property/create/";
const UPDATE_FORM_ONLY_PROP = "form-property/update/";
const DELETE_FORM_ONLY_PROP = "form-property/";
const UPDATE_FORM_FIELD = "form-property/update-contact-field/";
const FORM_FIELD = "form-property/contact-field/";
const SAVE_TEMPLATE_PROPERTY = "form-property/save-template-property/";
const CONTACT_LIST = "list-dropdown";
const USER_LIST = "user-list";
const SHARE_FORM = "form/share/";

export default {
  createForm(params) {
    return http.post(FORM_URL, params);
  },
  updateForm(params, id, cb) {
    return http.patch(FORM_URL + "/" + id, params);
  },
  getForm(id, cb) {
    return http.get(FORM_URL + "/" + id).then(function (response) {
      cb(response);
    });
  },
  getTemplates(cb) {
    return http.get(TEMPLATE_URL).then(function (response) {
      cb(response);
    });
  },
  getFrequentFields(params, cb) {
    return http.post(FREQUENT_URL, params).then(function (response) {
      cb(response);
    });
  },
  getCustomFields(params, cb) {
    return http.post(CUSTOM_FIELD_URL, params).then(function (response) {
      cb(response);
    });
  },
  saveCustomField(params) {
    return http.post(SAVE_CUSTOM_FIELD, params);
  },
  publishForm(id) {
    return http.patch(PUBLISH_FORM + id);
  },
  saveFormOnlyProperty(params, formId) {
    return http.post(SAVE_FORM_ONLY_PROP + formId, params);
  },
  addFormProperty(params, formId, propId) {
    return http.post(SAVE_FORM_FIELD + formId + "/" + propId, params);
  },
  updateFormProperty(params, formId, propId) {
    return http.put(UPDATE_FORM_FIELD + formId + "/" + propId, params);
  },
  updateFormOnlyProperty(params, formId, propId) {
    return http.post(UPDATE_FORM_ONLY_PROP + formId + "/" + propId, params);
  },
  viewFormProperty(formId, propId) {
    return http.get(FORM_FIELD + formId + "/" + propId);
  },
  deleteFormProperty(formId, propId) {
    return http.deleteRecord(FORM_FIELD + formId + "/" + propId);
  },
  deleteFormOnlyProperty(formId, propId) {
    return http.deleteRecord(DELETE_FORM_ONLY_PROP + formId + "/" + propId);
  },
  getReport(url, params) {
    return http.post(url, params);
  },
  saveTemplateProperty(formId, tempId) {
    return http.post(SAVE_TEMPLATE_PROPERTY + formId + "/" + tempId);
  },
  searchList(params, cb) {
    return http.post(CONTACT_LIST, params).then(function (response) {
      cb(response);
    });
  },
  searchUsers(params, cb) {
    return http.post(USER_LIST, params).then(function (response) {
      cb(response);
    });
  },
  shareForm(id) {
    return http.get(SHARE_FORM + id);
  },
};
